module.exports = __webpack_public_path__ + "img/voucher_used.ce387670.svg";